import React from "react";
import { useNavigate } from "react-router-dom";
import "./BlogPage.css";

function BlogPage() {
  const navigate = useNavigate();

  const blogs = [
    {
      slug: "sex-toys-in-delhi",
      image: "/image/blog1.jpg",
      title: "Sex Toys in Delhi – Buy Online with Discreet Delivery | LushDesire.in",
      desc: "Looking to buy sex toys in Delhi? Shop premium pleasure products online with 100% discreet packaging across Delhi NCR."
    },
    {
      slug: "sex-toys-in-mumbai",
      image: "/image/blog2.jpg",
      title: "Sex Toys in Mumbai – Trusted Online Sex Toy Store in India",
      desc: "Order sex toys online in Mumbai from LushDesire.in with privacy protection, safe billing and fast delivery."
    },
    {
      slug: "sex-toys-in-bangalore",
      image: "/image/blog3.jpg",
      title: "Sex Toys in Bangalore – Safe, Private & Discreet Shopping",
      desc: "Buy sex toys in Bangalore online with complete privacy. Premium quality pleasure products delivered discreetly."
    },
    {
      slug: "sex-toys-in-hyderabad",
      image: "/image/blog1.jpg",
      title: "Sex Toys in Hyderabad – Online Delivery Across India",
      desc: "Discover high-quality sex toys in Hyderabad with trusted delivery and secure checkout from LushDesire.in."
    },
    {
      slug: "sex-toys-in-chennai",
      image: "/image/blog2.jpg",
      title: "Sex Toys in Chennai – Discreet Online Sex Toy Store",
      desc: "Looking for sex toys in Chennai? Buy online from LushDesire.in with stealth packaging and premium products."
    },
    {
      slug: "sex-toys-in-pune",
      image: "/image/blog3.jpg",
      title: "Sex Toys in Pune – Buy Premium Pleasure Products Online",
      desc: "Order sex toys online in Pune with safe payment, private delivery and best prices in India."
    },
    {
      slug: "sex-toys-in-kolkata",
      image: "/image/blog1.jpg",
      title: "Sex Toys in Kolkata – Online Store with Complete Privacy",
      desc: "Shop sex toys in Kolkata from LushDesire.in. Discreet packaging, premium quality and fast shipping."
    }
  ];

  return (
    <section
      className="blog-pag"
      aria-label="Sex toys blogs for major Indian cities"
    >
      {/* 🔥 MAIN SEO H1 */}
      <h1 className="blog-title">
        Premium Sex Toys in India with 100% Privacy | LushDesire.in
     </h1>


      <div className="blog-container">
        {blogs.map((blog, i) => (
          <article className="blog-cardd" key={i}>
            <img
              src={blog.image}
              alt={blog.title}
              className="blog-img"
              loading="lazy"
            />

            {/* 🔥 SEO H2 */}
            <h1 className="blog-headingg">{blog.title}</h1>

            <p className="blog-desc">{blog.desc}</p>

            <button
              className="blog-btn"
              onClick={() => navigate(`/blog/${blog.slug}`)}
              aria-label={`Read more about ${blog.title}`}
            >
              Read More
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}

export default BlogPage;
